<div class="TabContent Flexbox Justify--space-around">
  <ng-container *ngFor="let group of customizationGroups">
    <button class="TabButton" mat-flat-button (click)="groupSelected(group)">{{ group.name }}</button>
  </ng-container>
</div>
